module.exports = __webpack_public_path__ + "img/zdlyLb_banner.d4931c0.png";